import type {companyGroupState} from './types'

import {atom, useAtomValue} from 'jotai'

import store from '..'

const companyGroupAtom = atom<companyGroupState>((get) => get(store).companyGroup)

export const useCompanyGroupSelector = () => {
  const companyGroup = useAtomValue(companyGroupAtom)
  return {companyGroup}
}
